<template>
  <v-card :loading="loading" :disabled="loading">
    <v-card-title>
      รายงานค้างค่าธรรมเนียมการศึกษา
    </v-card-title>
    <v-card-text>
      <v-simple-table class="mb-5" height="520" fixed-header dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">
                #
              </th>
              <th class="text-center">
                ชื่อ
              </th>
              <th class="text-center">
                นามสกุล
              </th>
              <th class="text-center">
                รหัสบัตรประชาชน
              </th>
              <th class="text-center">
                อีเมล
              </th>
              <th class="text-center">
                เบอร์มือถือ
              </th>
              <th class="text-center">
                เลขที่ใบสมัคร
              </th>
              <th class="text-center">
                สถานะการสมัคร
              </th>
              <th class="text-center">
                อยู่ในระบบรายงานตัว
              </th>
              <th class="text-center">
                รหัสนักศึกษาเดิม
              </th>
              <th class="text-center">
                ค่าธรรมเนียมรวม (บาท)
              </th>
              <th class="text-center">
                ยอดชำระแล้วรวม (บาท)
              </th>
              <th class="text-center">
                ยอดค้างรวม (บาท)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data_list" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.STUDENT_FNAME_TH }}</td>
              <td>{{ item.STUDENT_LNAME_TH }}</td>
              <td>{{ item.CITIZEN_ID }}</td>
              <td>{{ item.EMAIL }}</td>
              <td>{{ item.MOBILE }}</td>
              <td>{{ item.REGISTER_ID }}</td>
              <td>{{ item.MEANING_TH }}</td>
              <td class="text-center">
                <v-icon color="info" v-if="item.MASTER_REG_UID">
                  mdi-check-circle
                </v-icon>
              </td>
              <td>
                <div
                  v-for="(item2, index2) in item.student_id_list"
                  :key="index2"
                >
                  {{ item2 }}
                </div>
              </td>
              <td class="text-right">{{ addCommas(item.regis_summary) }}</td>
              <td class="text-right">{{ addCommas(item.billing_summary) }}</td>
              <td class="red--text font-weight-bold text-right">
                {{ addCommas(item.remaining_summary) }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import ReportsProvider from "@/services/reports.provider";

const reportsService = new ReportsProvider();

export default {
  name: "NotPaidTuitionFee",

  data: () => ({
    loading: false,
    data_list: null,
  }),

  methods: {
    async fetchData() {
      this.loading = true;
      this.data_list = await reportsService.getNotPaidTuitionFee();
      this.loading = false;
    },

    addCommas(num) {
      if (num === null || num === undefined) {
        return num;
      }
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },

  created() {
    this.fetchData();
  },
};
</script>
